import { EncryptionsAccessLogDeviceTypeEntity } from '../entities';
import { authResource } from './Auth';
export const EncryptionsAccessLogDeviceTypeResource = authResource({
    path: '/encryptions/:encryptionId/accesslogs/devicetypes/:deviceTypeId?',
    schema: EncryptionsAccessLogDeviceTypeEntity
});
